import { Message } from '@oneflowab/pomes';

import ExternalLink from 'components/icons/external-link';
import Button from 'components/button';

import { amplitudeLogEvent } from 'client-analytics/amplitude';
import style from './support-link.module.scss';

export const SupportLink = () => (
  <>
    <Message
      id="Need help?"
      comment="Used as the text in support link description"
    />
    {' '}
    <Button
      kind="link"
      className={style.LinkButton}
      href="mailto:support@oneflow.com"
      external
      onClick={() => {
        amplitudeLogEvent('Contact Support', { location: 'subscription plan canceled modal' });
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Message
        id="Contact support."
        comment="Used as the text in support link description"
      />
      <ExternalLink className={style.ExternalLink} height="12px" />
    </Button>
  </>
);
